export default function handleChange(info, setData, parentKey = null) {
    const { name, value } = info.target;
    let updatedValue = value;
    if (name === 'phoneNumber') {
        updatedValue = value.replace(/\D/g, '').slice(0, 10);
    }
    if (parentKey) {
        setData((prevState) => ({
            ...prevState,
            [parentKey]: {
                ...prevState[parentKey],
                [name]: value
            }
        }));
    } else {
        setData((prevState) => ({
            ...prevState,
            [name]: updatedValue
        }));
    }
}

export function handleInputChange(event, setData) {
    const { name, value, type } = event.target;
    console.log(name, value, type);
    setData((prevState) => ({
        ...prevState,
        [name]: type === 'number' ? Number(value) : value
    }));
}
